export const URLS = {
  GET_ORGANISATIONS: '/api/dynamic/Shesha/Organisation/Crud/GetAll',
};
